import { Button, Input, Space, Table, Empty, Spin, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddProductModal from '../../Modal/AddProductModal';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import EditProductModal from '../../Modal/EditProductModal';
import { mainAxios } from '../../middleware/interceptor';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import { MdDeleteOutline } from "react-icons/md";
import dayjs from 'dayjs';
import { toast } from 'react-toastify'
import DeleteProductModal from '../../Modal/DeleteProductModal';
import DeleteSubCategoryModal from '../../Modal/DeleteSubCategoryModal';
import DeleteCountSheetModal from '../../Modal/DeleteCountSheetModal';
import { LoadingOutlined } from '@ant-design/icons';

function AddAndEditCountSheet({ setAddAndEditCountSheet, UpdateCountSheet, CountSheetData }) {
  const [inventoryName, setInventoryName] = useState(CountSheetData?.CountSheetName);
  const [countSheetId, setCountSheetId] = useState(CountSheetData?.CountSheetId);
  const [countSheetDetails, setCountSheetDetails] = useState([]);
  const [productModal, setProductModal] = useState(false);
  const [editProductModal, setEditProductModal] = useState(false);
  const [RestID, setRestId] = useState(localStorage.getItem('RestId'));
  const [dynamoData, setDynamoData] = useState([]);
  const [categoryDropdown, setCategoryDropDown] = useState([]);
  const [subCategoryRawData, setSubCategoryRawData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [isGrouped, setIsGrouped] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [deleteCountSheetModal, setDeleteCountSheetModal] = useState(false);
  const [deleteProductModal, setDeleteProductModal] = useState(false);
  const [deleteProduct, setDeleteProduct] = useState(null);
  const [deleteSubCategoryModal, setDeleteSubCategoryModal] = useState(false);
  const [deleteSubCategory, setDeleteSubCategory] = useState(null);
  const [isEditCountSheetName, setIsEditCountSheetName] = useState(false);
  const [filteredSubCategoryIds, setFilteredSubCategoryIds] = useState([]);
  const [selectedSubCategoryIds, setSelectedSubCategoryIds] = useState([]);
  const [listOfSubCategoryIds, setListOfSubcategoryIds] = useState([])

  const countSheetStatus = CountSheetData.Status;

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const handleDeleteProduct = (record) => {
    setDeleteProductModal(true);
    setDeleteProduct(record);
  };

  const handleDeleteSubCategory = (record, index) => {
    setDeleteSubCategoryModal(true);
    setDeleteSubCategory({ ...record, countSheetId, index: index });
  };

  const columns = (data, catId) => [
    {
      title: '',
      dataIndex: '',
      key: '',
      width: 40,
      align: 'center',
      render: () => (
        <RestaurantIcon color='#b10303' fontSize='12' />
      ),
    },
    {
      title: `Product : ${data?.Product}`,
      dataIndex: 'SubProduct',
      key: 'SubProduct',
      width: 400,
    },
    {
      title: 'Recent Purchased',
      dataIndex: 'LastPurchaseDate',
      key: 'LastPurchaseDate',
      // width: 250,
      render: (cell) => (
        <>
          {dayjs(cell).format('MM/DD/YYYY')}
        </>
      )
    },
    {
      title: 'Count By',
      dataIndex: 'subProductUnit',
      width: 300,
      key: 'subProductUnit',
    },
    {
      title: 'Price',
      dataIndex: 'subProductPrice',
      key: 'price',
      align: 'left',
      width: 130,
      onHeaderCell: () => ({
        className: 'left-align-header',
      }),
      onCell: () => ({
        className: 'left-align-body',
      }),
      render: (cell) => (
        <>
          {currencyFormatter.format(cell)}
        </>
      )
    },
    {
      title: 'Action',
      dataIndex: 'subProductId',
      key: 'subProductId',
      width: 100,
      align: 'center',
      render: (_, record) => (
        <>
          <Button
            style={{
              border: 0,
              color: '#6a8ab9',
              padding: 5,
              boxShadow: 'none',
              backgroundColor: 'transparent',
              fontSize: '18px'
            }}
            //disabled={countSheetStatus === 0}
            onClick={() => { setSelectedProduct({ ...record, CountSheetId: countSheetId, cat_id: catId?.CatId, catName: catId?.CatName, ProductId: data?.ProductId }); setEditProductModal(true); }}
          >
            <ModeEditRoundedIcon color='#b10303' fontSize='14' />
          </Button>

          <Button
            style={{
              border: 0,
              color: '#b10303',
              padding: 5,
              boxShadow: 'none',
              backgroundColor: 'transparent',
              fontSize: '18px'
            }}
            //disabled={countSheetStatus === 0}
            onClick={() => {
              handleDeleteProduct({ ...record, CountSheetId: countSheetId, cat_id: catId?.CatId, catName: catId?.CatName, ProductId: data?.ProductId });
            }}
          >
            <HighlightOffIcon color='#b10303' fontSize='14' />
          </Button>
        </>
      )
    },
  ];

  const getData = () => {
    let req = {
      "RestId": RestID,
      "Inventorykey": "null",
      "page_status": 1
    }
    mainAxios
      .post('/api/Inventory', req)
      .then(res => {
        setDynamoData(res.data);
      })
      .catch(err => {
        setDynamoData([]);
        console.log(err);
        setIsGrouped(true);
      })
  };

  const getCategories = () => {
    mainAxios.get('api/Inventory/Getcategories/' + RestID).then(res => {
      const temp = res.data.Categorydetails
      setCategoryDropDown(temp)
    })
  };

  const getSubCategories = () => {
    mainAxios
      .get('api/Inventory/GetSubCategories/' + RestID)
      .then(res => {
        setSubCategoryRawData(res.data.SubCategoryArray);
        let temp = res.data.SubCategoryArray.flatMap(a => a.SubCategories.map(b => b.SubCategoryId));
        setListOfSubcategoryIds(temp);
      })
      .catch(err => {
        console.log(err);
      })
  };

  const addSubProductInCountSheet = (value) => {
    let req = value?.productCode === 1 ? {
      "restid": RestID,
      "countsheetName": inventoryName,
      "countsheetId": countSheetId,
      "countsheetDetails": [
        {
          "catId": value?.cat_id,
          "catName": value?.cat_name,
          "subCatId": [],
          "productCode": value?.productCode,
          "productList": value?.SubProductId
        }
      ],
      "canEditCountSheetName": 0
    } : {
      "restid": RestID,
      "countsheetName": inventoryName,
      "countsheetId": countSheetId,
      "countsheetDetails": value?.categoryList,
      "canEditCountSheetName": 0
    }


    mainAxios.post(`api/Inventory/addCountsheet`, req).then((res) => {
      if (res?.data?.Status == "1") {
        toast.success('Product added successfully');
        UpdateCountSheet(countSheetId);
        setProductModal(false);
      } else {
        toast.warning('Failed to add a product');
      }
    }).catch((err) => { console.log(err) })

  };

  const handleDeactivate = async () => {
    const params = {
      RestId: RestID,
      CountSheetId: countSheetId,
      status: 0
    };

    await mainAxios.post('api/Inventory/changeStatusoftheCountsheets', params).then((res) => {
      if (res?.data?.status == 1) {
        toast.success('Count sheet deactivated successfully');
        UpdateCountSheet(countSheetId);
        setProductModal(false);
      } else {
        toast.warning('Failed to deactivate');
      }
    }).catch((err) => { console.error(err) });
  };

  const handleActivate = async () => {
    const params = {
      RestId: RestID,
      CountSheetId: countSheetId,
      status: 1
    };

    await mainAxios.post('api/Inventory/changeStatusoftheCountsheets', params).then((res) => {
      if (res?.data?.status == 1) {
        toast.success('Count sheet activated successfully');
        UpdateCountSheet(countSheetId);
        setProductModal(false);
      } else {
        toast.warning('Failed to activate');
      }
    }).catch((err) => { console.error(err) });
  };

  const handleDelete = async () => {
    const params = {
      RestId: RestID,
      CountSheetId: countSheetId,
      status: 2
    };

    await mainAxios.post('api/Inventory/changeStatusoftheCountsheets', params).then((res) => {
      if (res?.data?.status == 1) {
        toast.success('Count sheet deleted successfully');
        UpdateCountSheet(countSheetId);
        setAddAndEditCountSheet(false);
        setProductModal(false)
      } else {
        toast.warning('Failed to delete');
      }
    }).catch((err) => { console.error(err) });
  };

  const handleEditCountSheetName = () => {
    if (CountSheetData?.CountSheetName === inventoryName.trim()) {
      setIsEditCountSheetName(false);
      return false;
    }

    let req = {
      "restid": RestID,
      "countsheetName": inventoryName,
      "countsheetId": countSheetId,
      "countsheetDetails": [],
      "canEditCountSheetName": 1
    };

    mainAxios.post(`api/Inventory/addCountsheet`, req).then((res) => {
      if (res?.data?.Status == "1") {
        toast.success('Count Sheet Name Changed Successfully');
        setIsEditCountSheetName(false);
        UpdateCountSheet(countSheetId);
      } else {
        toast.warning('Failed to Change Count Sheet Name');
        setIsEditCountSheetName(false);
        UpdateCountSheet(countSheetId);
      }
    }).catch((err) => { console.log(err); setIsEditCountSheetName(false); });
  };

  const getSelectedSubCategoryIds = (InventoryDetails) => {
    if (!Array.isArray(InventoryDetails)) {
      console.error('Invalid InventoryDetails data');
      return [];
    }

    const extractedData = InventoryDetails.flatMap((category) =>
      category.GroupedItems?.map((group) => ({
        SubCategoryId: group.SubCategoryId,
        SubCatName: group.SubCatName,
        selectedProducts: group.productList?.map((product) => ({
          ProductId: product.ProductId,
          ProductName: product.Product,
          selectedSubProducts: product.subproductlist?.map((subProduct) => ({
            subProductId: subProduct.subProductId,
            subProductName: subProduct.SubProduct,
          })) || [],
        })) || [],
      })) || []
    );

    setSelectedSubCategoryIds(extractedData);
  };

  const showEmpty = () => {
    if (countSheetDetails.length === 0) {
      return true;
    } else {
      return !countSheetDetails.some(a => a.GroupedItems.length > 0);
    }
  }

  useEffect(() => {
    getData();
    getCategories();
    getSubCategories();
  }, []);

  useEffect(() => {
    setInventoryName(CountSheetData?.CountSheetName);
    let temp = CountSheetData?.InventoryDetails?.map((a) => ({
      ...a,
      GroupedItems: a.GroupedItems.map((b) => ({
        ...b,
        productList: b.productList.map((c) => ({
          ...c,
          subproductlist: c.subproductlist.map((d) => ({
            ...d,
            subProductUnit: !d.itemsList[0]?.BaseUnit ? d?.subProductUnit : d.itemsList[0]?.BaseUnit,
            subProductPrice:
              !d.itemsList[0]?.BaseUnit
                ? d.subProductPrice
                : (d.itemsList[0]?.UnitCountby == 0 || !d.itemsList[0]?.UnitCountby)
                  ? d.itemsList[0]?.Price
                  : (parseFloat(d.itemsList[0]?.Price) / parseFloat(d.itemsList[0]?.UnitCountby)).toFixed(2),
            itemsList: d.itemsList.map((e) => (
              {
                ...e,
                UnitCountby: (e?.UnitCountby == 0 || !e?.UnitCountby) ? 1 : e?.UnitCountby,
                changedPrice:
                  (e?.UnitCountby == 0 || !e?.UnitCountby)
                    ? e.Price
                    : (parseFloat(e?.Price) / parseFloat(e?.UnitCountby)).toFixed(2),
              }
            )
            )
          })),
        })),
      })),
    }));
    getSelectedSubCategoryIds(temp);
    setCountSheetDetails(temp)
  }, [CountSheetData]);

  useEffect(() => {
    if (dynamoData?.Data) {
      if (
        dynamoData.Data?.InventoryDetails &&
        dynamoData.Data?.InventoryDetails?.length > 0
      ) {
        const temp = [];
        const da = dynamoData?.Data?.InventoryDetails.map(cat => {
          temp.push({
            label: cat?.CatName,
            value: `${cat?.CatName}~${cat?.CatId}`
          });

          return cat.Items.map(item => ({
            subCategory: item?.SubCatName || '',
            SubCategoryId: item?.SubCategoryId || '',
            catId: cat?.CatId,
            id: item?.id,
            CatName: cat?.CatName,
            ProductId: item?.ProductId || '',
            ProductName: item?.Product || '',
            SubProductName: item?.SubProduct || '',
            SubProductId: item?.subProductId || '',
          }));
        });
        let test = da.flat();

        let result = test.filter((a) => ((!!a?.subCategory && !!a?.ProductName && !!a?.SubProductName && !!a?.SubCategoryId && !!a?.ProductId && !!a?.SubProductId)));


        let ProductList = result.map((a) => (
          {
            label: `${a.ProductName} - ${a.SubProductName}`,
            value: `${a.ProductName} - ${a.SubProductName}`,
            cat_id: a.catId,
            cat_name: a.CatName,
            SubCategoryId: a.SubCategoryId,
            ProductId: a.ProductId,
            SubProductId: a.SubProductId
          }
        ));
        let FilterProductList = Array.from(new Map(ProductList.map(obj => [obj.value, obj])).values());
        // Flatten the array and set the products
        setProducts(FilterProductList);
        //setFilteredSubCategoryIds(result.map(item => item.SubCategoryId));
        setFilteredSubCategoryIds(result);
      }
    }
  }, [dynamoData]);

  useEffect(() => {
    if (categoryDropdown.length > 0 && filteredSubCategoryIds.length > 0) {
      // Step 1: Group by SubCategoryId
      const subCategoryMap = new Map();

      filteredSubCategoryIds.forEach(item => {
        if (!item.catId || !item.SubCategoryId) {
          console.warn("Skipping invalid item:", item);
          return;
        }

        if (!subCategoryMap.has(item.SubCategoryId)) {
          subCategoryMap.set(item.SubCategoryId, {
            SubCategoryId: item.SubCategoryId,
            SubCatName: item.subCategory,
            Products: []
          });
        } else {
          return
        }

        let subCategory = subCategoryMap.get(item.SubCategoryId);

        // Find existing product under this subcategory
        let product = subCategory?.Products?.find(p => p.ProductId === item.ProductId);
        if (!product) {
          product = {
            ProductId: item.ProductId,
            ProductName: item.ProductName,
            SubProducts: []
          };
          subCategory.Products.push(product);
        }

        // Add subproduct to the product
        product.SubProducts.push({
          subProductId: item.SubProductId,
          subProductName: item.SubProductName
        });
      });

      // Step 2: Group subcategories under categories correctly
      const transformedData = categoryDropdown.map(category => {
        if (!category.Cat_id) {
          console.warn("Skipping invalid category:", category);
          return null;
        }

        // Filter only those subcategories that belong to this category
        const subCategories = Array.from(subCategoryMap.values()).filter(sub => {
          return filteredSubCategoryIds.some(item =>
            item.catId && category.Cat_id &&
            item.catId.toString() === category.Cat_id.toString() &&
            item.SubCategoryId && sub.SubCategoryId &&
            item.SubCategoryId === sub.SubCategoryId
          );
        });

        return {
          CatId: category.Cat_id,
          CatName: category.Cat_name,
          SubCategories: subCategories // ✅ Ensuring subcategories are added correctly
        };
      }).filter(Boolean); // Remove null values

      setGroupedData(transformedData);
      setIsGrouped(true);
    }
  }, [categoryDropdown, filteredSubCategoryIds]);

  return (
    <div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'start', marginBottom: '10px' }}>
        <Button
          // style={{ padding: 0, border: 'none', boxShadow: 'none' }}
          className='backButton'
          onClick={() => setAddAndEditCountSheet(false)}
          title='Back'
        >
          <ChevronLeftIcon />
        </Button>
        <h4 style={{ fontSize: '20px', margin: '0' }}>Edit Count Sheet</h4>
      </div>
      <div className='actionContainer'>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'space-between', marginTop: '20px', marginLeft: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label style={{ fontSize: '15px', position: 'relative', top: '-2px' }} className='label'>Count Sheet Name : </label>
            <div style={{ width: '300px' }}>
              <Input
                value={inventoryName}
                onChange={e => setInventoryName(e.target.value)}
                style={{ width: '100%' }}
                disabled={!isEditCountSheetName}
              />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              {!isEditCountSheetName && (
                <Button onClick={() => setIsEditCountSheetName(true)} >
                  <Space>
                    Edit
                  </Space>
                </Button>
              )}
              {isEditCountSheetName && (
                <>
                  <Button onClick={() => setIsEditCountSheetName(false)} className='Deactivate-Button'>
                    <Space>
                      Cancel
                    </Space>
                  </Button>
                  <Button onClick={handleEditCountSheetName} className='printButton2'>
                    <Space>
                      Save
                    </Space>
                  </Button>
                </>
              )}
            </div>
          </div>

          <div>
            <div>
              <Button
                className='printButton'
                icon={<AddIcon />}
                onClick={() => {
                  setProductModal(true);
                  setIsEditCountSheetName(false);
                  setInventoryName(CountSheetData?.CountSheetName);
                }}
                disabled={!isGrouped}
              >
                <Space>
                  Add Product
                  <RestaurantIcon fontSize='16' />
                </Space>
              </Button>
            </div>
          </div>
        </div>
        <hr />
        <div className='productsContainer'>
          {!isGrouped && (
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 48,
                      color: '#19a73f'
                    }}
                    spin
                  />
                }
              />
            </div>
          )}
          {isGrouped && showEmpty() && (
            <div
              className=''
              style={{
                height: '60vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={() => {
                setProductModal(true);
                setIsEditCountSheetName(false);
                setInventoryName(CountSheetData?.CountSheetName);
              }}
            >
              <Empty
                image="/no-item.png"
                styles={{
                  image: {
                    height: 60,
                  },
                }}
                description={
                  <Typography.Text>
                    Please Add Product
                  </Typography.Text>
                }
              >
                {/* <Button
                  className='printButton'
                  icon={<AddIcon />}
                  onClick={() => {
                    setProductModal(true);
                    setIsEditCountSheetName(false);
                    setInventoryName(CountSheetData?.CountSheetName);

                  }}
                  disabled={!isGrouped}
                >
                  <Space>
                    Add Product
                    <RestaurantIcon fontSize='16' />
                  </Space>
                </Button> */}
              </Empty>
            </div>
          )}
          {isGrouped && countSheetDetails.length > 0 && countSheetDetails?.map((Cat) => (
            <>
              {Cat?.GroupedItems.length > 0 && <span style={{ fontWeight: 500, fontSize: '20px' }}>{Cat?.CatName}</span>}
              {
                Cat?.GroupedItems.length > 0 && (Cat?.GroupedItems.map((GroupItem, index) => (
                  <div className='productsTableContainer'>
                    <div className='productsTable'>
                      <div className='subCategoryInput'>
                        <div className='head-box'>
                          <span>SubCategory : {GroupItem?.SubCatName}</span>
                          <MdDeleteOutline
                            style={{ fontSize: '20px', color: '#ff4e4e', cursor: 'pointer' }}
                            onClick={() => { handleDeleteSubCategory(Cat, index) }}
                          />
                        </div>
                        {GroupItem?.productList?.map((Product) => (
                          <>
                            <div>
                              <Table
                                dataSource={Product?.subproductlist}
                                columns={columns(Product, Cat)}
                                pagination={false}
                                size={'small'}
                              />
                            </div>
                          </>
                        ))
                        }
                      </div>
                    </div>
                  </div>
                ))
                )
              }
            </>
          ))}
        </div>
        <div style={{ margin: '15px 0', display: 'flex', gap: 10, justifyContent: 'end' }}>
          <Button onClick={() => { setDeleteCountSheetModal(true) }} danger type="primary">
            <Space>
              Delete
            </Space>
          </Button>
          {countSheetStatus === 1 && (
            <Button onClick={handleDeactivate} type="primary" className='Deactivate-Button'>
              <Space>
                Deactivate
              </Space>
            </Button>
          )}
          {countSheetStatus === 0 && (
            <Button onClick={handleActivate} className='printButton2'>
              <Space>
                Activate
              </Space>
            </Button>
          )}
        </div>
      </div>
      <AddProductModal
        visible={productModal}
        setVisible={setProductModal}
        dropDownData={groupedData}
        productsList={products}
        addProduct={addSubProductInCountSheet}
        selectedSubCategoryIds={selectedSubCategoryIds}
      />
      <EditProductModal
        visible={editProductModal}
        setVisible={setEditProductModal}
        editData={selectedProduct}
        updateCountSheet={UpdateCountSheet}
      />
      <DeleteCountSheetModal
        visible={deleteCountSheetModal}
        setVisible={setDeleteCountSheetModal}
        handleDeleteConfirm={handleDelete}
      />
      <DeleteProductModal
        visible={deleteProductModal}
        setVisible={setDeleteProductModal}
        deleteProduct={deleteProduct}
        updateCountSheet={UpdateCountSheet}
      />
      <DeleteSubCategoryModal
        visible={deleteSubCategoryModal}
        setVisible={setDeleteSubCategoryModal}
        deleteSubCategory={deleteSubCategory}
        updateCountSheet={UpdateCountSheet}
      />
    </div>
  )
};

export default AddAndEditCountSheet;
